import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
  WritableSignal,
  signal,
} from '@angular/core';
import { ActionButton } from '@shared/abstraction/grid/action-button';

@Component({
  standalone: false,
  selector: 'gstar-action-menu',
  templateUrl: './action-menu.component.html',
  styleUrls: ['./action-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionMenuComponent<TData> {
  @Input() actionMenu?: ActionButton<TData>[];
  @Input() rowData!: TData;

  @ViewChild('contextMenu', { read: ElementRef, static: false })
  contextMenu!: ElementRef;

  isShow: WritableSignal<boolean> = signal(false);

  toggle(): void {
    this.isShow.set(!this.isShow());
  }

  @HostListener('window:click', ['$event'])
  clickOutside(event: Event): void {
    if (!this.contextMenu.nativeElement.contains(event.target)) {
      this.isShow.set(false);
    }
  }
}
